import React from 'react';
import { FilterOptions } from 'src/features/types/r2fTypes';

interface R2FFilterControlsProps {
    filters: FilterOptions;
    onFilterChange: (newFilters: FilterOptions) => void;
    availableProductionCapabilities: string[];
    availableHandlingTiers: string[];
}

/**
 * Filter controls for R2F threshold table
 */
export const R2FFilterControls: React.FC<R2FFilterControlsProps> = ({
    filters,
    onFilterChange,
    availableProductionCapabilities,
    availableHandlingTiers
}) => {
    return (
        <div className="filter-controls">
            <div className="filter-group">
                <label>Production Capability:</label>
                <input 
                    type="text" 
                    value={filters.productionCapability} 
                    onChange={e => onFilterChange({...filters, productionCapability: e.target.value})}
                    placeholder="Filter by production capability"
                />
            </div>
            <div className="filter-group">
                <label>Handling Tier:</label>
                <select 
                    value={filters.handlingTier}
                    onChange={e => onFilterChange({...filters, handlingTier: e.target.value})}
                >
                    <option value="">All Handling Tiers</option>
                    {availableHandlingTiers.map(handlingTier => (
                        <option key={handlingTier} value={handlingTier}>{handlingTier}</option>
                    ))}
                </select>
            </div>
            <div className="filter-group">
                <label>Status:</label>
                <select
                    value={filters.status}
                    onChange={e => onFilterChange({...filters, status: e.target.value})}
                >
                    <option value="">Any Status</option>
                    <option value="unchanged">Unchanged</option>
                    <option value="modified">Modified</option>
                </select>
            </div>
        </div>
    );
};
